import { SORT_MAALI, SORT_SARJA } from '../actions/types'
 
 export const sortReducerMaali = (state = 'descending', action) => {
   switch (action.type) {
     case SORT_MAALI:
       return action.sortmaali
     default:
       return state
   }
 }

 export const sortReducerSarja = (state = '', action) => {
    switch (action.type) {
      case SORT_SARJA:
        return action.sortsarja
      default:
        return state
    }
  }